"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchToastModal = void 0;
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const Flex_1 = require("@amzn/atoz-web/Flex");
const Theme_1 = require("@amzn/atoz-web/Theme");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ToastIcon_1 = require("../Shared/ToastIcon");
const PunchToastModal = ({ dataTestId, title, subTitle, text, subText, note, closeBtnText, status, closeModal }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: dataTestId || 'PunchToastModal', onCloseButtonClick: closeModal, closeButtonAltText: t('time_and_attendance_Close'), titleText: "", buttons: [
            react_1.default.createElement(Button_1.Button, { style: { width: '100%' }, key: "PunchToastModalConfirmButton", variant: Button_1.ButtonVariant.Primary, dataTestId: "PunchToastModalConfirmButton", onClick: closeModal, "aria-label": closeBtnText || t('time_and_attendance_PunchToastModal_Ok') }, closeBtnText || t('time_and_attendance_PunchToastModal_Ok'))
        ] },
        react_1.default.createElement(View_1.View, { margin: { top: 'S500' } },
            react_1.default.createElement(IconTitleWrapper, null,
                react_1.default.createElement(ToastIcon_1.ToastIcon, { status: status }),
                react_1.default.createElement(Text_1.H1, { fontWeight: 500, fontSize: "T500", margin: { top: 'S200' } }, title)),
            react_1.default.createElement(Text_1.Text, { textAlign: "center", color: "neutral80", margin: { bottom: 'S400' } }, text),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: "column", rowGap: 8 },
                subTitle && react_1.default.createElement(Text_1.H2, { fontSize: "T500" }, subTitle),
                subText && react_1.default.createElement(Text_1.Text, { color: "neutral80" }, subText)),
            note && (react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral80" }, note)))));
};
exports.PunchToastModal = PunchToastModal;
const IconTitleWrapper = (0, Theme_1.styledWithTheme)(View_1.View)(({ theme }) => `
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.selectors.space('S200')}px;
  `);
